import {Injectable} from '@angular/core';
import {EparcoursPath} from '../../constantes/menu/menu-items/eparcours-path';
import {NavService} from './nav-service';
import {Router} from '@angular/router';
import {PARAM_TOKEN} from './navigators/navigators';

@Injectable({
  providedIn: 'root',
})
export class PersonnelsNavService extends NavService {
  constructor(router: Router) {
    super(router);
  }

  edition = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.PERSONNELS,
    EparcoursPath.personnels.EDITION,
    PARAM_TOKEN,
    EparcoursPath.personnels.EDITION_GENERAL,
  );

  creation = this.makeNavigator(EparcoursPath.root.PERSONNELS, EparcoursPath.personnels.CREATION);

  liste = this.makeNavigator(EparcoursPath.root.PERSONNELS);

  utilisateur = this.makeNavigatorWith2Params<number, string>(
    EparcoursPath.root.PERSONNELS,
    EparcoursPath.personnels.EDITION,
    PARAM_TOKEN,
    EparcoursPath.personnels.EDITION_GENERAL,
    EparcoursPath.personnels.EDITION_UTILISATEUR,
    PARAM_TOKEN,
  );
}
